<div class="login-register" [ngStyle]="{'background-image': isDelete ? '' : 'url(assets/images/background/login-bg5.jpg)' }">
  <div class="login-register-box">

    <mat-card class="m-t-10">
      <mat-card-content>
        <form [formGroup]="loginForm" (submit)="getCredentialsForDel()" autocomplete="off" novalidate="novalidate" id="loginform" class="login-form">
          <div class="text-center">
            <img alt="homepage" class="main-logo margin-bottom" src="assets/images/iotechlogo.png">
          </div><br>

          <div fxLayout="row wrap">

            <div fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">
              <mat-form-field appearance="outline" class="p-b-15" class="test">
                <mat-icon matPrefix *ngIf="!type">person</mat-icon>
                <mat-label>Username</mat-label>
                <input matInput type="text" (focus)="userNameFocus()" placeholder="Username" #u1 formControlName="userName" autocomplete="off" autofocus />
                <mat-error *ngIf="isControlHasError('userName', 'required')">
                  User name is required
                </mat-error>
                <mat-error *ngIf="isControlHasError('userName', 'minlength')">
                  Must be atleast 3 characters long
                </mat-error>
              </mat-form-field>
            </div>
            <!-- col full-->
            <div fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100" class="m-t-10">
              <mat-form-field appearance="outline" class="p-b-5">
                <mat-icon matPrefix *ngIf="!type">lock</mat-icon>
                <mat-label>Password</mat-label>
                <input *ngIf="isFireFox; else notFireFox;" matInput type="password" #p2 formControlName="password" />
                <ng-template #notFireFox>
                <input matInput [type]="inputType" style="-webkit-text-security: circle;" #p2 formControlName="password" />
                </ng-template>
                <mat-error *ngIf="isControlHasError('password', 'required')">
                  Password is required
                </mat-error>
                <mat-error *ngIf="isControlHasError('password', 'minlength')">
                  Must be atleast 3 characters long
                </mat-error>
              </mat-form-field>
            </div>

            <div fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100" *ngIf="!isDelete">
              <button mat-raised-button color="primary" class="btn-block btn-lg m-t-2 m-b-2" (click)="submit()"
                type="button">
                <span *ngIf="!processingLoginRequest">
                  Login
                </span>
                <span *ngIf="processingLoginRequest">
                  Processing Request...
                </span>
              </button>
            </div>
            <div fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100" *ngIf="isDelete">

              <div mat-dialog-actions>
                <button mat-button class="btn-no" type="button" (click)="getCredentialsForDel('no')">No</button>
                <button mat-raised-button type="submit" [ngClass]="type === entityTypes.ASSETS ? 'btn-delete-asset' : 'btn-delete-dashboard' " (click)="getCredentialsForDel()"
                  [disabled]="loginForm.invalid">{{ isDashboardPage ? 'Submit' : 'Delete'}}</button>
              </div>
            </div>

          </div>
        </form>
      </mat-card-content>
    </mat-card>
  </div>
</div>
